/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCopy: {
  name: 'copy';
  data: string;
} = {
  name: 'copy',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 .5A1.5 1.5 0 0 0 .5 2v6A1.5 1.5 0 0 0 2 9.5h4.5V14A1.5 1.5 0 0 0 8 15.5h6a1.5 1.5 0 0 0 1.5-1.5V8A1.5 1.5 0 0 0 14 6.5H9.5V2A1.5 1.5 0 0 0 8 .5H2Zm6.5 6V2a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h4.5V8A1.5 1.5 0 0 1 8 6.5h.5ZM7.5 9v5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.5.5v1Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
